// extracted by mini-css-extract-plugin
export default {"fullWidth":"Pl-z","image":"Ql-z","lazyLoadPicture":"Rl-z","lazyLoadSpinner":"Sl-z","lazyLoadSpin":"Tl-z","lazyLoadImage":"Ul-z","hasStyledAspectRatio":"Vl-z"};